// Owner: custom-components (F20). `/apps`: the workspace's custom components (the apps of the rail and the
// blocks of Home), built in the visual builder or described to the Copilot.
import { createFileRoute } from '@tanstack/react-router';
import { ComponentsPage } from '../../../features/custom-components/ComponentsPage';

export const Route = createFileRoute('/_app/apps/')({ component: ComponentsPage });
